#version 300 es
    
precision highp float;
precision highp sampler3D;

in vec3 pass_textureCoordinates;

out vec4 color;

uniform vec2 windowLevel; //ww, wc
uniform vec3 colorMask;
uniform float alpha;
uniform int isPrimary;
// The corner four tiles meet at, in gl_FragCoord pixels (+x right,
// +y up): the plane intersection point, so the pattern follows the
// crosshair. The images stay fixed.
uniform vec2 checkerboardOrigin;
// One tile's edge per axis, in the same pixels, already scaled from its
// length on the image plane at the view's zoom.
uniform vec2 checkerboardTilePx;

uniform sampler3D sampler;

vec4 colorModification(float value, float alphaValue) {
    value = (value - windowLevel.y + (windowLevel.x * 0.5)) / windowLevel.x;
    value *= alphaValue;
    vec3 color = colorMask * value;
    return vec4(color, 1.0);
}

void main() {

    // Get window coordinates (pixels) from gl_FragCoord
    vec2 windowCoord = gl_FragCoord.xy;

    // Which tile the fragment falls in, counted from the origin. GLSL
    // mod() is always non-negative for a positive divisor, so tiles on
    // the far side of the origin alternate correctly too.
    vec2 tileIndex = floor((windowCoord - checkerboardOrigin) / checkerboardTilePx);
    bool isChecker1 = mod(tileIndex.x, 2.0) == mod(tileIndex.y, 2.0);

    if (isPrimary == 0) {
        isChecker1 = !isChecker1;
    }

    float alphaValue = isChecker1 ? alpha : 0.0;

    // Sample from the texture and apply the alpha value
    float value = texture(sampler, pass_textureCoordinates).r;
    color = colorModification(value, alphaValue);
}